module.exports = __webpack_public_path__ + "img/copy_w.3ba80cf8.svg";